import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { withLang, langType } from '../../i18n';
import envConfig from '../../constants/env';
import { routes } from '../../constants';

import styles from './footer.module.css';

import logoUrl from '../../images/fd-logo.svg';
import linkIconUrl from '../../images/external-link.svg';

const ExternalLink = ({
  label, href, translate
}) => (
  <a
    className={styles.footerLink}
    href={href}
    target="_blank"
    rel="noopener noreferrer"
  >
    <span>{label}</span>
    <img src={linkIconUrl} alt={translate('footer.externalLink')} data-cy="footer-external-link-icon" />
  </a>
);

const Footer = ({ translate, lang }) => (
  <footer className={styles.footer} role="contentinfo">
    <div className={styles.footerContent}>
      <div className={styles.logo}>
        <a
          href={envConfig.FOOTER.funidataUrl[lang]}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={logoUrl} alt="Funidata" />
        </a>
      </div>
      <ExternalLink
        href={envConfig.FOOTER.dpsUrl[lang]}
        label={translate('footer.dps')}
        translate={translate}
      />
      <Link
        target="_blank"
        to={routes.accessibilityStatement}
        className={styles.footerLink}
      >
        <span>{translate('footer.accessibilityStatement')}</span>
      </Link>
    </div>
  </footer>
);

ExternalLink.propTypes = {
  label: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  translate: PropTypes.func.isRequired
};

Footer.propTypes = langType;
export default withLang(Footer);
